import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import JobManagementTable from "./jobTable";
import { InfoBox } from "../designUi";
import { MessageIconCover } from "../UIElements/svgIcons";

import { JobBoardProps } from "../../interface/job_board";
import { Pagination } from "../Pagination";
import { useState } from "react";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { FilterJobsInputs } from "./FilterInputs";
import { formatDecimal, formatDecimalNumber } from "../../utils/url-id";

const JobBoardContent = ({
  jobList,
  isLoading,
  stats,
  setFilterData,
  setPaginationState,
  paginationState,
}: JobBoardProps) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const [compare, setCompare] = useState(false);
  return (
    <Stack sx={{ padding: 2, marginTop: 70 }}>
      <Grid container>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Job"}
            value={stats.totalDocuments}
            icon={<MessageIconCover />}
          />
        </Grid>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Accepted Rate"}
            value={Number(formatDecimalNumber(stats.metrics.metrics.acceptanceRate))}
            icon={<MessageIconCover />}
          />
        </Grid>{" "}
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Applicants"}
            value={stats.metrics.metrics.totalApplicants}
            icon={<MessageIconCover />}
          />
        </Grid>{" "}
      </Grid>

      <Box sx={{ m: 2 }}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ mb: 3 }}
        >
          <Typography
            variant="subtitle2"
            color={"neutral"}
            sx={{ fontWeight: 700, fontFamily: "Inter" }}
          >
            Jobs
          </Typography>
          <Button onClick={() => setCompare(!compare)}>
            {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
          </Button>
        </Stack>
        <Stack
          sx={{
            background: theme.palette.common.white,
            borderRadius: 2,
            py: 3,
          }}
        >
          {compare && (
            <FilterJobsInputs
              loading={isLoading}
              setFilterData={setFilterData}
            />
          )}
          <JobManagementTable data={jobList} loading={isLoading} />
          <Pagination
            paginationState={paginationState}
            setPaginationState={setPaginationState}
          />
        </Stack>
      </Box>
    </Stack>
  );
};

export default JobBoardContent;
